import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center" }
const _hoisted_2 = {
  src: "/img/elipse_selected_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_3 = {
  src: "/img/elipse_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_4 = { class: "tw-flex cell-name" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  src: "/img/elipse_selected_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_7 = {
  src: "/img/elipse_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_8 = { class: "name tw-flex tw-items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "information tw-flex tw-flex-none tw-flex-col tw-mr-12" }
const _hoisted_11 = { class: "name tw-font-semibold" }
const _hoisted_12 = { class: "email tw-text-xs grey-color" }
const _hoisted_13 = { class: "tw-flex" }
const _hoisted_14 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", { d: "M9.71177 3.66897C9.6655 3.54707 9.58343 3.44202 9.47634 3.36765C9.36924 3.29328 9.24215 3.25307 9.11177 3.2523H6.52427L5.5951 0.6273C5.54991 0.505124 5.46838 0.399723 5.36149 0.325283C5.25459 0.250843 5.12745 0.210937 4.99718 0.210938C4.86692 0.210937 4.73978 0.250843 4.63288 0.325283C4.52598 0.399723 4.44445 0.505124 4.39927 0.6273L3.47427 3.24813H0.886767C0.754567 3.24585 0.624929 3.28474 0.515806 3.3594C0.406683 3.43406 0.323473 3.5408 0.277701 3.66484C0.231928 3.78889 0.225857 3.9241 0.260328 4.05174C0.2948 4.17939 0.368107 4.29316 0.4701 4.3773L2.66593 6.19397L1.74927 8.9523C1.70572 9.08093 1.70438 9.22011 1.74546 9.34955C1.78654 9.47899 1.86787 9.59194 1.97762 9.67192C2.08737 9.75191 2.21979 9.79476 2.3556 9.79423C2.4914 9.79369 2.62348 9.74981 2.7326 9.66897L4.99927 8.0023L7.26593 9.66897C7.37505 9.74981 7.50714 9.79369 7.64294 9.79423C7.77874 9.79476 7.91116 9.75191 8.02091 9.67192C8.13066 9.59194 8.212 9.47899 8.25307 9.34955C8.29415 9.22011 8.29282 9.08093 8.24927 8.9523L7.32843 6.19397L9.52843 4.37313C9.62669 4.28812 9.69683 4.17529 9.72956 4.04955C9.7623 3.92381 9.75609 3.7911 9.71177 3.66897ZM6.5451 5.7148C6.47606 5.76919 6.42598 5.84402 6.40203 5.92858C6.37809 6.01315 6.38149 6.10312 6.41177 6.18563L7.0826 8.21063C7.09048 8.2321 7.09107 8.25556 7.0843 8.2774C7.07752 8.29923 7.06375 8.31823 7.0451 8.33147C7.02642 8.34534 7.00378 8.35282 6.98052 8.35282C6.95725 8.35282 6.93461 8.34534 6.91593 8.33147L5.24927 7.1148C5.17366 7.06134 5.08353 7.03226 4.99093 7.03147C4.89825 7.03172 4.80796 7.06085 4.7326 7.1148L3.0826 8.33563C3.06392 8.3495 3.04128 8.35699 3.01802 8.35699C2.99475 8.35699 2.97211 8.3495 2.95343 8.33563C2.93388 8.32219 2.9195 8.30247 2.91268 8.27973C2.90586 8.257 2.90701 8.23262 2.91593 8.21063L3.58677 6.18563C3.61704 6.10312 3.62045 6.01315 3.5965 5.92858C3.57255 5.84402 3.52248 5.76919 3.45343 5.7148L1.78677 4.3148C1.76885 4.30101 1.75591 4.28176 1.74989 4.25996C1.74388 4.23816 1.74512 4.215 1.75343 4.19397C1.76031 4.17267 1.77362 4.15402 1.79153 4.14059C1.80943 4.12716 1.83106 4.11961 1.85343 4.11897H3.7826C3.87328 4.12014 3.96209 4.09311 4.03674 4.0416C4.11139 3.99009 4.16818 3.91666 4.19927 3.83147L4.89927 1.8398C4.90771 1.8191 4.92213 1.80139 4.94068 1.78892C4.95923 1.77645 4.98108 1.76979 5.00343 1.76979C5.02579 1.76979 5.04763 1.77645 5.06619 1.78892C5.08474 1.80139 5.09916 1.8191 5.1076 1.8398L5.8076 3.83147C5.83869 3.91666 5.89548 3.99009 5.97013 4.0416C6.04478 4.09311 6.13358 4.12014 6.22427 4.11897H8.1701C8.19304 4.11936 8.21531 4.12675 8.23393 4.14015C8.25255 4.15356 8.26662 4.17234 8.27427 4.19397C8.28258 4.215 8.28382 4.23816 8.27781 4.25996C8.2718 4.28176 8.25885 4.30101 8.24093 4.3148L6.5451 5.7148Z" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "tw-flex tw-items-center" }
const _hoisted_18 = {
  src: "/img/elipse_selected_icon.svg",
  alt: "eclipse_icon"
}
const _hoisted_19 = {
  src: "/img/elipse_icon.svg",
  alt: "eclipse_icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropDownItem = _resolveComponent("CustomDropDownItem")!
  const _component_ButtonShowMore = _resolveComponent("ButtonShowMore")!
  const _component_b_table = _resolveComponent("b-table")!

  return (!_ctx.isSkeleton)
    ? (_openBlock(), _createBlock(_component_b_table, {
        key: 0,
        ref: "manageRoleTable",
        items: _ctx.tableData,
        fields: _ctx.tableFields,
        striped: true,
        responsive: "sm",
        "thead-class": "tb-bg-gray",
        class: _normalizeClass(['setting-table']),
        "tbody-tr-class": _ctx.rowClass
      }, {
        "head(info)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "icon-select",
              type: "button",
              "data-cy": "manage-role-table-select-all",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSelectAll(!_ctx.isSelectAll)))
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
                [_vShow, _ctx.isSelectAll]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [
                [_vShow, !_ctx.isSelectAll]
              ])
            ]),
            _createElementVNode("span", null, _toDisplayString(data.label.toUpperCase()), 1)
          ])
        ]),
        "cell(info)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "icon-select",
              type: "button",
              onClick: ($event: any) => (_ctx.toggleDetails(data.index))
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                [_vShow, _ctx.selected[data.index]?.isSelectedRow]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                [_vShow, !_ctx.selected[data.index]?.isSelectedRow]
              ])
            ], 8, _hoisted_5),
            _createElementVNode("div", _hoisted_8, [
              (data.value?.imgSrc)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: data.value?.imgSrc,
                    alt: "person_random"
                  }, null, 8, _hoisted_9))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(`${data.value.firstName} ${data.value.lastName}`), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(data.value.email), 1)
              ])
            ])
          ])
        ]),
        "cell(roles)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (role, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "cell-role tw-text-sm tw-font-medium tw-flex tw-items-center"
              }, [
                _createElementVNode("span", null, _toDisplayString(role.role), 1),
                (role.isStart)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        "cell(actions)": _withCtx((data) => [
          _createVNode(_component_ButtonShowMore, {
            "id-popover": 'popover-btn-show-more-manage-role-table-' + data.index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropDownItem, {
                style: 'normal',
                "id-text": 'app-settings-team-roles-more-modal-remove-user-1',
                onClick: () => _ctx.$emit('delete:one_row', data.item)
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["id-popover"])
        ]),
        _: 1
      }, 8, ["items", "fields", "tbody-tr-class"]))
    : (_openBlock(), _createBlock(_component_b_table, {
        key: 1,
        items: [{}, {}, {}],
        fields: _ctx.filedSkeleton,
        striped: true,
        responsive: "sm",
        "thead-class": "tb-bg-gray",
        class: _normalizeClass(['setting-table'])
      }, {
        "head(info)": _withCtx((data) => [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "icon-select",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSelectAll(!_ctx.isSelectAll)))
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_18, null, 512), [
                [_vShow, _ctx.isSelectAll]
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_19, null, 512), [
                [_vShow, !_ctx.isSelectAll]
              ])
            ]),
            _createElementVNode("span", null, _toDisplayString(data.label.toUpperCase()), 1)
          ])
        ]),
        _: 1
      }, 8, ["fields"]))
}